export default {
  home: '/',
  host: (roomId = ':roomId'): string => `/${roomId}/host`,
  participate: (roomId = ':roomId'): string => `/${roomId}/participate`,
};
